import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('transition-group', {
    class: [_vm.$style.Drawer, _defineProperty({}, _vm.$style.disableDefaultPaddings, _vm.disableDefaultPaddings)],
    attrs: {
      "appear": "",
      "duration": "1000",
      "tag": "div",
      "data-ios-should-lock-scroll": ""
    },
    on: {
      "enter": _vm.enter,
      "leave": _vm.leave,
      "after-leave": _vm.afterLeave
    }
  }, [_vm.show ? [_c('SimpleOverlay', {
    key: "overlay",
    ref: "overlay",
    attrs: {
      "id": _vm.DRAWER_IDS.OVERLAY
    },
    on: {
      "clicked": _vm.handleCloseStart
    }
  }), _vm._v(" "), _c('div', {
    key: "fullscreen",
    attrs: {
      "id": "drawer-fullscreen"
    }
  }, [_vm._t("fullscreen")], 2), _vm._v(" "), _c('div', {
    key: "body",
    class: [_vm.$style.body, _vm.bodyClasses],
    attrs: {
      "id": _vm.DRAWER_IDS.BODY
    }
  }, [_c('SButton', {
    class: _vm.$style.closeButton,
    attrs: {
      "id": _vm.DRAWER_IDS.CLOSE,
      "equal": "",
      "theme": "ghost"
    },
    on: {
      "click": _vm.handleCloseStart
    }
  }, [_c('SIcon', {
    attrs: {
      "icon": "i-close",
      "size": "24"
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "bodyInner",
    class: _vm.$style.inner,
    attrs: {
      "id": _vm.DRAWER_IDS.BODY_INNER
    }
  }, [_c('div', {
    class: _vm.$style.bodyInner,
    attrs: {
      "id": "drawer-body-inner"
    }
  }, [_vm._t("default")], 2)])], 1)] : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };